import React from 'react';
import MarkdownWithViz from '../../MarkdownWithViz';

const reqPrefix = 'src/markdowns/longBeach/welcome';
const req = require.context('!raw-loader!../../../markdowns/longBeach/welcome', false, /\.(md|jsx)$/);

export default function Welcome() {
  return <MarkdownWithViz req={req} reqSource={req} reqPrefix={reqPrefix} />;
}
